import "./ibn_index.d02ae500.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired6a0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired6a0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ih19M = parcelRequire("ih19M");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $9d7r6 = parcelRequire("9d7r6");

var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $2a76d3643f5fa154$var$SelectableContext = /*#__PURE__*/ $bh6RR.createContext(null);
const $2a76d3643f5fa154$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $2a76d3643f5fa154$export$2e2bcd8739ae039 = $2a76d3643f5fa154$var$SelectableContext;


function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $bh6RR = parcelRequire("bh6RR");
var $fb89ab44c0e57c1a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $fb89ab44c0e57c1a$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$fb89ab44c0e57c1a$exports = $fb89ab44c0e57c1a$var$invariant;


var $c3326696b9cf35f6$var$noop = function noop() {};
function $c3326696b9cf35f6$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $c3326696b9cf35f6$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $c3326696b9cf35f6$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$c3326696b9cf35f6$export$26cbf8c37e721e67(prop)] = $c3326696b9cf35f6$var$noop;
        var handler;
    });
    return propTypes;
}
function $c3326696b9cf35f6$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $c3326696b9cf35f6$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $c3326696b9cf35f6$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $94e0357acb68c07d$var$_toPropertyKey(arg) {
    var key = $94e0357acb68c07d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $94e0357acb68c07d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $94e0357acb68c07d$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $bh6RR.useRef)(propValue !== undefined);
    var _useState = (0, $bh6RR.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $bh6RR.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $94e0357acb68c07d$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$c3326696b9cf35f6$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref, [
            $c3326696b9cf35f6$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($94e0357acb68c07d$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $94e0357acb68c07d$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, o);
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c45633f7e501ae27$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c45633f7e501ae27$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c45633f7e501ae27$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c45633f7e501ae27$var$componentWillMount.__suppressDeprecationWarning = true;
$c45633f7e501ae27$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c45633f7e501ae27$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c45633f7e501ae27$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c45633f7e501ae27$var$componentWillMount;
        prototype.componentWillReceiveProps = $c45633f7e501ae27$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c45633f7e501ae27$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $c1318f9cbc3ac07a$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $c1318f9cbc3ac07a$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $c3326696b9cf35f6$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($c3326696b9cf35f6$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$c3326696b9cf35f6$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$c3326696b9cf35f6$export$12ae2baa35bd9b8b(props, key) && $c3326696b9cf35f6$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$c3326696b9cf35f6$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
    (0, $c45633f7e501ae27$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $c3326696b9cf35f6$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(UncontrolledComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $c1318f9cbc3ac07a$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $c1318f9cbc3ac07a$export$2e2bcd8739ae039(newComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $c172ce2c4551a6fb$var$NavbarBrand = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix)
    });
});
$c172ce2c4551a6fb$var$NavbarBrand.displayName = 'NavbarBrand';
var $c172ce2c4551a6fb$export$2e2bcd8739ae039 = $c172ce2c4551a6fb$var$NavbarBrand;



var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $d371e635ce29e576$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $434773c79742c8d2$export$2e2bcd8739ae039(node) {
    var doc = (0, $d371e635ce29e576$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $3ba1b5578e0ae054$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $434773c79742c8d2$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $31bc1e28303345b6$var$rUpper = /([A-Z])/g;
function $31bc1e28303345b6$export$2e2bcd8739ae039(string) {
    return string.replace($31bc1e28303345b6$var$rUpper, '-$1').toLowerCase();
}


var $d2f1a5f247a8f6c5$var$msPattern = /^ms-/;
function $d2f1a5f247a8f6c5$export$2e2bcd8739ae039(string) {
    return (0, $31bc1e28303345b6$export$2e2bcd8739ae039)(string).replace($d2f1a5f247a8f6c5$var$msPattern, '-ms-');
}


var $b30c5d01ed96a9b3$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $b30c5d01ed96a9b3$export$2e2bcd8739ae039(value) {
    return !!(value && $b30c5d01ed96a9b3$var$supportedTransforms.test(value));
}


function $955899dea657b290$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $d2f1a5f247a8f6c5$export$2e2bcd8739ae039)(property)) || (0, $3ba1b5578e0ae054$export$2e2bcd8739ae039)(node).getPropertyValue((0, $d2f1a5f247a8f6c5$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $d2f1a5f247a8f6c5$export$2e2bcd8739ae039)(key));
        else if ((0, $b30c5d01ed96a9b3$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $d2f1a5f247a8f6c5$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $955899dea657b290$export$2e2bcd8739ae039 = $955899dea657b290$var$style;



var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
var $2d4434ad62cd5cee$export$2e2bcd8739ae039 = {
    disabled: false
};




var $bh6RR = parcelRequire("bh6RR");
var $51a0807799a59896$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);


var $ecfd1cf4e45b6881$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $5875a5c0de10c551$export$bb38bb9a1161268 = 'unmounted';
var $5875a5c0de10c551$export$84cbff306f539230 = 'exited';
var $5875a5c0de10c551$export$df38205c966be359 = 'entering';
var $5875a5c0de10c551$export$78e9e6e3e014d60a = 'entered';
var $5875a5c0de10c551$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5875a5c0de10c551$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
                _this.appearStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else initialStatus = $5875a5c0de10c551$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5875a5c0de10c551$export$bb38bb9a1161268;
        else initialStatus = $5875a5c0de10c551$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5875a5c0de10c551$export$bb38bb9a1161268) return {
            status: $5875a5c0de10c551$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5875a5c0de10c551$export$df38205c966be359 && status !== $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$df38205c966be359;
            } else if (status === $5875a5c0de10c551$export$df38205c966be359 || status === $5875a5c0de10c551$export$78e9e6e3e014d60a) nextStatus = $5875a5c0de10c551$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5875a5c0de10c551$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $ecfd1cf4e45b6881$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5875a5c0de10c551$export$84cbff306f539230) this.setState({
            status: $5875a5c0de10c551$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2d4434ad62cd5cee$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5875a5c0de10c551$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5875a5c0de10c551$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2d4434ad62cd5cee$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $5875a5c0de10c551$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5875a5c0de10c551$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5875a5c0de10c551$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5875a5c0de10c551$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $51a0807799a59896$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$5875a5c0de10c551$var$Transition.contextType = (0, $51a0807799a59896$export$2e2bcd8739ae039);
$5875a5c0de10c551$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5875a5c0de10c551$var$noop() {}
$5875a5c0de10c551$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5875a5c0de10c551$var$noop,
    onEntering: $5875a5c0de10c551$var$noop,
    onEntered: $5875a5c0de10c551$var$noop,
    onExit: $5875a5c0de10c551$var$noop,
    onExiting: $5875a5c0de10c551$var$noop,
    onExited: $5875a5c0de10c551$var$noop
};
$5875a5c0de10c551$var$Transition.UNMOUNTED = $5875a5c0de10c551$export$bb38bb9a1161268;
$5875a5c0de10c551$var$Transition.EXITED = $5875a5c0de10c551$export$84cbff306f539230;
$5875a5c0de10c551$var$Transition.ENTERING = $5875a5c0de10c551$export$df38205c966be359;
$5875a5c0de10c551$var$Transition.ENTERED = $5875a5c0de10c551$export$78e9e6e3e014d60a;
$5875a5c0de10c551$var$Transition.EXITING = $5875a5c0de10c551$export$4aacc83d4d59139f;
var $5875a5c0de10c551$export$2e2bcd8739ae039 = $5875a5c0de10c551$var$Transition;



var $bh6RR = parcelRequire("bh6RR");
function $420f2d7c4fc516e3$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $420f2d7c4fc516e3$export$13e065f3a74cfe36() {
    const parts = $bh6RR.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $420f2d7c4fc516e3$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $420f2d7c4fc516e3$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $622988aebba4f369$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $14266d52a448926a$export$63fefd044b2bc624 = false;
var $14266d52a448926a$export$a614c6b395900f69 = false;
try {
    var $14266d52a448926a$var$options = {
        get passive () {
            return $14266d52a448926a$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $14266d52a448926a$export$a614c6b395900f69 = $14266d52a448926a$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $622988aebba4f369$export$2e2bcd8739ae039) {
        window.addEventListener('test', $14266d52a448926a$var$options, $14266d52a448926a$var$options);
        window.removeEventListener('test', $14266d52a448926a$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $14266d52a448926a$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$14266d52a448926a$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$14266d52a448926a$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $14266d52a448926a$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $14266d52a448926a$export$2e2bcd8739ae039 = $14266d52a448926a$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $ccf83f3d128bf500$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $ccf83f3d128bf500$export$2e2bcd8739ae039 = $ccf83f3d128bf500$var$removeEventListener;


function $43719bf4460d82c3$var$listen(node, eventName, handler, options) {
    (0, $14266d52a448926a$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $ccf83f3d128bf500$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $43719bf4460d82c3$export$2e2bcd8739ae039 = $43719bf4460d82c3$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $6b619ba4807f5d18$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $fefd07e34208fde6$var$parseDuration(node) {
    var str = (0, $955899dea657b290$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $fefd07e34208fde6$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $6b619ba4807f5d18$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $43719bf4460d82c3$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $fefd07e34208fde6$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $fefd07e34208fde6$var$parseDuration(element) || 0;
    var removeEmulate = $fefd07e34208fde6$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $43719bf4460d82c3$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $60d2376c6489a351$var$parseDuration(node, property) {
    const str = (0, $955899dea657b290$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $60d2376c6489a351$export$2e2bcd8739ae039(element, handler) {
    const duration = $60d2376c6489a351$var$parseDuration(element, 'transitionDuration');
    const delay = $60d2376c6489a351$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $fefd07e34208fde6$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $fd853bb669f4f145$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $fd853bb669f4f145$export$2e2bcd8739ae039 = $fd853bb669f4f145$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $aabdf1043b5f639f$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
const $890c1a0691b04d01$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $890c1a0691b04d01$export$c9058316764c140e(refA, refB) {
    const a = $890c1a0691b04d01$var$toFnRef(refA);
    const b = $890c1a0691b04d01$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $890c1a0691b04d01$var$useMergedRefs(refA, refB) {
    return (0, $bh6RR.useMemo)(()=>$890c1a0691b04d01$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $890c1a0691b04d01$export$2e2bcd8739ae039 = $890c1a0691b04d01$var$useMergedRefs;



var $6afFj = parcelRequire("6afFj");
function $3fab24bb6dbb2fa4$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



var $ih19M = parcelRequire("ih19M");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $3eabe32fb6c1d688$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $bh6RR.useRef)(null);
    const mergedRef = (0, $890c1a0691b04d01$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $3fab24bb6dbb2fa4$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $bh6RR.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $bh6RR.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $bh6RR.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $bh6RR.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $bh6RR.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $bh6RR.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $bh6RR.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $5875a5c0de10c551$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$3eabe32fb6c1d688$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $3eabe32fb6c1d688$export$2e2bcd8739ae039 = $3eabe32fb6c1d688$var$TransitionWrapper;



var $ih19M = parcelRequire("ih19M");
const $1b4fad8595dff2b7$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $1b4fad8595dff2b7$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $1b4fad8595dff2b7$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $955899dea657b290$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $955899dea657b290$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $1b4fad8595dff2b7$var$collapseStyles = {
    [(0, $5875a5c0de10c551$export$84cbff306f539230)]: 'collapse',
    [(0, $5875a5c0de10c551$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $5875a5c0de10c551$export$df38205c966be359)]: 'collapsing',
    [(0, $5875a5c0de10c551$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $1b4fad8595dff2b7$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $1b4fad8595dff2b7$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $bh6RR.useMemo)(()=>(0, $fd853bb669f4f145$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $bh6RR.useMemo)(()=>(0, $fd853bb669f4f145$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $bh6RR.useMemo)(()=>(0, $fd853bb669f4f145$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $bh6RR.useMemo)(()=>(0, $fd853bb669f4f145$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $aabdf1043b5f639f$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $bh6RR.useMemo)(()=>(0, $fd853bb669f4f145$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3eabe32fb6c1d688$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $60d2376c6489a351$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, children.props.className, $1b4fad8595dff2b7$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$1b4fad8595dff2b7$var$Collapse.displayName = 'Collapse';
var $1b4fad8595dff2b7$export$2e2bcd8739ae039 = $1b4fad8595dff2b7$var$Collapse;



var $5ozxM = parcelRequire("5ozxM");

var $bh6RR = parcelRequire("bh6RR");
"use client";
// TODO: check
const $e87fe3fc2803189b$var$context = /*#__PURE__*/ $bh6RR.createContext(null);
$e87fe3fc2803189b$var$context.displayName = 'NavbarContext';
var $e87fe3fc2803189b$export$2e2bcd8739ae039 = $e87fe3fc2803189b$var$context;



var $ih19M = parcelRequire("ih19M");
"use client";
const $ea601c8f500afd6f$var$NavbarCollapse = /*#__PURE__*/ $bh6RR.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    const context = (0, $bh6RR.useContext)((0, $e87fe3fc2803189b$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1b4fad8595dff2b7$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$ea601c8f500afd6f$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $ea601c8f500afd6f$export$2e2bcd8739ae039 = $ea601c8f500afd6f$var$NavbarCollapse;



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $448c2ad57ac2384c$var$useCommittedRef(value) {
    const ref = (0, $bh6RR.useRef)(value);
    (0, $bh6RR.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $448c2ad57ac2384c$export$2e2bcd8739ae039 = $448c2ad57ac2384c$var$useCommittedRef;


function $f3b5e78021297094$export$2e2bcd8739ae039(fn) {
    const ref = (0, $448c2ad57ac2384c$export$2e2bcd8739ae039)(fn);
    return (0, $bh6RR.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $5ozxM = parcelRequire("5ozxM");


var $ih19M = parcelRequire("ih19M");
"use client";
const $59915c67ecadcd7d$var$NavbarToggle = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $bh6RR.useContext)((0, $e87fe3fc2803189b$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $f3b5e78021297094$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $ih19M.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$59915c67ecadcd7d$var$NavbarToggle.displayName = 'NavbarToggle';
var $59915c67ecadcd7d$export$2e2bcd8739ae039 = $59915c67ecadcd7d$var$NavbarToggle;



var $bh6RR = parcelRequire("bh6RR");


var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");
const $5025a896a75abee8$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $5025a896a75abee8$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5025a896a75abee8$export$2e2bcd8739ae039 = $5025a896a75abee8$var$isDOM || $5025a896a75abee8$var$isReactNative ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);



var $bh6RR = parcelRequire("bh6RR");
const $6f901d5234b103d7$var$matchersByWindow = new WeakMap();
const $6f901d5234b103d7$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $6f901d5234b103d7$var$matchersByWindow.get(targetWindow) || new Map();
    $6f901d5234b103d7$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $6f901d5234b103d7$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $6f901d5234b103d7$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $bh6RR.useState)(()=>mql ? mql.matches : false);
    (0, $5025a896a75abee8$export$2e2bcd8739ae039)(()=>{
        let mql = $6f901d5234b103d7$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $6f901d5234b103d7$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $bh6RR = parcelRequire("bh6RR");
function $c66f4a5529732302$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $bh6RR.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $6f901d5234b103d7$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $c66f4a5529732302$var$useBreakpoint = $c66f4a5529732302$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $c66f4a5529732302$export$2e2bcd8739ae039 = $c66f4a5529732302$var$useBreakpoint;




var $bh6RR = parcelRequire("bh6RR");

function $b519d5f4b28aefee$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $d371e635ce29e576$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $b6dde0ad5073ca7b$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $bh6RR = parcelRequire("bh6RR");
function $c2cf2ecc313b24ab$export$2e2bcd8739ae039() {
    const mounted = (0, $bh6RR.useRef)(true);
    const isMounted = (0, $bh6RR.useRef)(()=>mounted.current);
    (0, $bh6RR.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $bh6RR = parcelRequire("bh6RR");
function $99b41f23f2f15e49$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $bh6RR.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $bh6RR = parcelRequire("bh6RR");
function $2b7b3e8d19b56841$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $99b41f23f2f15e49$export$2e2bcd8739ae039)(fn);
    (0, $bh6RR.useEffect)(()=>()=>onUnmount.current(), []);
}



var $bh6RR = parcelRequire("bh6RR");
function $ac2d89c2133d5a5d$export$2e2bcd8739ae039(value) {
    const ref = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $60bf0a902186ff6a$var$useCommittedRef(value) {
    const ref = (0, $bh6RR.useRef)(value);
    (0, $bh6RR.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $60bf0a902186ff6a$export$2e2bcd8739ae039 = $60bf0a902186ff6a$var$useCommittedRef;


function $8b53c13614d6c8a4$export$2e2bcd8739ae039(fn) {
    const ref = (0, $60bf0a902186ff6a$export$2e2bcd8739ae039)(fn);
    return (0, $bh6RR.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



const $54e82c94c8a6341a$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $54e82c94c8a6341a$export$635202801f9383a0 = `rrUi`;
function $54e82c94c8a6341a$export$5cc3b7b83e34ade7(property) {
    return `${$54e82c94c8a6341a$export$fd7bcb7e9bef4e8a}${property}`;
}
function $54e82c94c8a6341a$export$7776c0a7cd2eb3e0(property) {
    return `${$54e82c94c8a6341a$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $4cdab916e38b40e4$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $06285e45d03bb570$export$1a88c12b8b979fa0 = (0, $54e82c94c8a6341a$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $06285e45d03bb570$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $4cdab916e38b40e4$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $955899dea657b290$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($06285e45d03bb570$export$1a88c12b8b979fa0, '');
        (0, $955899dea657b290$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($06285e45d03bb570$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $06285e45d03bb570$export$2e2bcd8739ae039 = $06285e45d03bb570$var$ModalManager;





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

const $050f9ed094492ccf$var$Context = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $622988aebba4f369$export$2e2bcd8739ae039) ? window : undefined);
const $050f9ed094492ccf$export$f7d306aeb1cf5fbc = $050f9ed094492ccf$var$Context.Provider;
function $050f9ed094492ccf$export$2e2bcd8739ae039() {
    return (0, $bh6RR.useContext)($050f9ed094492ccf$var$Context);
}


const $a66548a60a771e40$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $622988aebba4f369$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $d371e635ce29e576$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $a66548a60a771e40$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $050f9ed094492ccf$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $bh6RR.useState)(()=>$a66548a60a771e40$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $a66548a60a771e40$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $bh6RR.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const nextRef = $a66548a60a771e40$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $bh6RR = parcelRequire("bh6RR");
const $c94e17ffa3b3dac8$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $c94e17ffa3b3dac8$export$c9058316764c140e(refA, refB) {
    const a = $c94e17ffa3b3dac8$var$toFnRef(refA);
    const b = $c94e17ffa3b3dac8$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $c94e17ffa3b3dac8$var$useMergedRefs(refA, refB) {
    return (0, $bh6RR.useMemo)(()=>$c94e17ffa3b3dac8$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $c94e17ffa3b3dac8$export$2e2bcd8739ae039 = $c94e17ffa3b3dac8$var$useMergedRefs;




var $bh6RR = parcelRequire("bh6RR");
const $f8d239d2b60467d0$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $f8d239d2b60467d0$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $f8d239d2b60467d0$export$2e2bcd8739ae039 = $f8d239d2b60467d0$var$isDOM || $f8d239d2b60467d0$var$isReactNative ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

function $64de839521ecf9b0$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $bh6RR.useRef)(null);
    const hasEnteredRef = (0, $bh6RR.useRef)(inProp);
    const handleExited = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(onExited);
    (0, $bh6RR.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $c94e17ffa3b3dac8$export$2e2bcd8739ae039)(ref, (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $64de839521ecf9b0$export$2e2bcd8739ae039 = $64de839521ecf9b0$var$NoopTransition;



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");


const $ace49ef752d04eaa$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $ace49ef752d04eaa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ace49ef752d04eaa$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $ace49ef752d04eaa$var$_objectWithoutPropertiesLoose(_ref, $ace49ef752d04eaa$var$_excluded);
    const nodeRef = (0, $bh6RR.useRef)(null);
    const mergedRef = (0, $c94e17ffa3b3dac8$export$2e2bcd8739ae039)(nodeRef, (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $bh6RR.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $bh6RR.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $bh6RR.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $bh6RR.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $bh6RR.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $bh6RR.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $bh6RR.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



var $ih19M = parcelRequire("ih19M");
const $bf469ed56b31a543$var$_excluded = [
    "component"
];
function $bf469ed56b31a543$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $bf469ed56b31a543$var$RTGTransition = /*#__PURE__*/ $bh6RR.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $bf469ed56b31a543$var$_objectWithoutPropertiesLoose(_ref, $bf469ed56b31a543$var$_excluded);
    const transitionProps = (0, $ace49ef752d04eaa$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $bf469ed56b31a543$export$2e2bcd8739ae039 = $bf469ed56b31a543$var$RTGTransition;




var $ih19M = parcelRequire("ih19M");
function $7c982996410393b5$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $bh6RR.useRef)(null);
    const isInitialRef = (0, $bh6RR.useRef)(true);
    const handleTransition = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(onTransition);
    (0, $f8d239d2b60467d0$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $f8d239d2b60467d0$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $7c982996410393b5$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $bh6RR.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $7c982996410393b5$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $c94e17ffa3b3dac8$export$2e2bcd8739ae039)(ref, (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ref: combinedRef
    });
}
function $7c982996410393b5$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bf469ed56b31a543$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $ih19M.jsx)($7c982996410393b5$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $64de839521ecf9b0$export$2e2bcd8739ae039), Object.assign({}, props));
}




var $ih19M = parcelRequire("ih19M");
const $a0abb309858b437e$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $a0abb309858b437e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $a0abb309858b437e$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $a0abb309858b437e$var$getManager(window) {
    if (!$a0abb309858b437e$var$manager) $a0abb309858b437e$var$manager = new (0, $06285e45d03bb570$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $a0abb309858b437e$var$manager;
}
function $a0abb309858b437e$var$useModalManager(provided) {
    const window = (0, $050f9ed094492ccf$export$2e2bcd8739ae039)();
    const modalManager = provided || $a0abb309858b437e$var$getManager(window);
    const modal = (0, $bh6RR.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $bh6RR.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $bh6RR.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $a0abb309858b437e$var$Modal = /*#__PURE__*/ (0, $bh6RR.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $a0abb309858b437e$var$_objectWithoutPropertiesLoose(_ref, $a0abb309858b437e$var$_excluded);
    const ownerWindow = (0, $050f9ed094492ccf$export$2e2bcd8739ae039)();
    const container = (0, $a66548a60a771e40$export$2e2bcd8739ae039)(containerRef);
    const modal = $a0abb309858b437e$var$useModalManager(providedManager);
    const isMounted = (0, $c2cf2ecc313b24ab$export$2e2bcd8739ae039)();
    const prevShow = (0, $ac2d89c2133d5a5d$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $bh6RR.useState)(!show);
    const lastFocusRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $622988aebba4f369$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $b519d5f4b28aefee$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $43719bf4460d82c3$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $43719bf4460d82c3$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $b519d5f4b28aefee$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $b6dde0ad5073ca7b$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $bh6RR.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $bh6RR.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $2b7b3e8d19b56841$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $b519d5f4b28aefee$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $b6dde0ad5073ca7b$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $420f2d7c4fc516e3$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $bh6RR.useRef)();
    const removeKeydownListenerRef = (0, $bh6RR.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $ih19M.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $bh6RR.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $7c982996410393b5$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $7c982996410393b5$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6afFj))).createPortal(/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$a0abb309858b437e$var$Modal.displayName = 'Modal';
var $a0abb309858b437e$export$2e2bcd8739ae039 = Object.assign($a0abb309858b437e$var$Modal, {
    Manager: (0, $06285e45d03bb570$export$2e2bcd8739ae039)
});



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");






var $ih19M = parcelRequire("ih19M");
const $337c19c74a9003c2$var$fadeStyles = {
    [(0, $5875a5c0de10c551$export$df38205c966be359)]: 'show',
    [(0, $5875a5c0de10c551$export$78e9e6e3e014d60a)]: 'show'
};
const $337c19c74a9003c2$var$Fade = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $bh6RR.useCallback)((node, isAppearing)=>{
        (0, $aabdf1043b5f639f$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3eabe32fb6c1d688$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $60d2376c6489a351$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $bh6RR.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('fade', className, children.props.className, $337c19c74a9003c2$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$337c19c74a9003c2$var$Fade.displayName = 'Fade';
var $337c19c74a9003c2$export$2e2bcd8739ae039 = $337c19c74a9003c2$var$Fade;



var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $289bed0efcf57119$var$OffcanvasBody = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix),
        ...props
    });
});
$289bed0efcf57119$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $289bed0efcf57119$export$2e2bcd8739ae039 = $289bed0efcf57119$var$OffcanvasBody;



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");





var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $e99d6b9e7fb9c6ac$var$transitionStyles = {
    [(0, $5875a5c0de10c551$export$df38205c966be359)]: 'show',
    [(0, $5875a5c0de10c551$export$78e9e6e3e014d60a)]: 'show'
};
const $e99d6b9e7fb9c6ac$var$OffcanvasToggling = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $3eabe32fb6c1d688$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $60d2376c6489a351$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $420f2d7c4fc516e3$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $bh6RR.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, children.props.className, (status === (0, $5875a5c0de10c551$export$df38205c966be359) || status === (0, $5875a5c0de10c551$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $e99d6b9e7fb9c6ac$var$transitionStyles[status])
            })
    });
});
$e99d6b9e7fb9c6ac$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $e99d6b9e7fb9c6ac$export$2e2bcd8739ae039 = $e99d6b9e7fb9c6ac$var$OffcanvasToggling;



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $9e099960a76146bb$var$ModalContext = /*#__PURE__*/ $bh6RR.createContext({
    onHide () {}
});
var $9e099960a76146bb$export$2e2bcd8739ae039 = $9e099960a76146bb$var$ModalContext;



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $5ozxM = parcelRequire("5ozxM");

var $bh6RR = parcelRequire("bh6RR");


var $eCfBx = parcelRequire("eCfBx");

var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $ih19M = parcelRequire("ih19M");
const $337f4057cc1c5a03$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOf([
        'white'
    ])
};
const $337f4057cc1c5a03$var$CloseButton = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $ih19M.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$337f4057cc1c5a03$var$CloseButton.displayName = 'CloseButton';
$337f4057cc1c5a03$var$CloseButton.propTypes = $337f4057cc1c5a03$var$propTypes;
var $337f4057cc1c5a03$export$2e2bcd8739ae039 = $337f4057cc1c5a03$var$CloseButton;




var $ih19M = parcelRequire("ih19M");
"use client";
const $2ace3acb8fa9ad58$var$AbstractModalHeader = /*#__PURE__*/ $bh6RR.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $bh6RR.useContext)((0, $9e099960a76146bb$export$2e2bcd8739ae039));
    const handleClick = (0, $f3b5e78021297094$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $ih19M.jsx)((0, $337f4057cc1c5a03$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$2ace3acb8fa9ad58$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $2ace3acb8fa9ad58$export$2e2bcd8739ae039 = $2ace3acb8fa9ad58$var$AbstractModalHeader;



var $ih19M = parcelRequire("ih19M");
"use client";
const $976fc9c8d19d1497$var$OffcanvasHeader = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2ace3acb8fa9ad58$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$976fc9c8d19d1497$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $976fc9c8d19d1497$export$2e2bcd8739ae039 = $976fc9c8d19d1497$var$OffcanvasHeader;



var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $ih19M = parcelRequire("ih19M");
var $5079edec7ed7e0fb$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $bh6RR.forwardRef((p, ref)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(p.className, className)
        }));



var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $eb64af4354022640$var$DivStyledAsH5 = (0, $5079edec7ed7e0fb$export$2e2bcd8739ae039)('h5');
const $eb64af4354022640$var$OffcanvasTitle = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $eb64af4354022640$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix),
        ...props
    });
});
$eb64af4354022640$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $eb64af4354022640$export$2e2bcd8739ae039 = $eb64af4354022640$var$OffcanvasTitle;



var $5ozxM = parcelRequire("5ozxM");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $33b01e299dbd30cd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $2141d70f922d7814$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $33b01e299dbd30cd$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}



var $f94b1ae4682370af$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $f94b1ae4682370af$export$2e2bcd8739ae039(element, selector) {
    return $f94b1ae4682370af$var$toArray(element.querySelectorAll(selector));
}


function $3f93ee659ef6c470$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $3f93ee659ef6c470$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $3f93ee659ef6c470$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $3f93ee659ef6c470$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $2a31db1208c463c9$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $2a31db1208c463c9$var$BootstrapModalManager extends (0, $06285e45d03bb570$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $955899dea657b290$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $955899dea657b290$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $955899dea657b290$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $2141d70f922d7814$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $3f93ee659ef6c470$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(container, $2a31db1208c463c9$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $2a31db1208c463c9$var$sharedManager;
function $2a31db1208c463c9$export$a03641438014b436(options) {
    if (!$2a31db1208c463c9$var$sharedManager) $2a31db1208c463c9$var$sharedManager = new $2a31db1208c463c9$var$BootstrapModalManager(options);
    return $2a31db1208c463c9$var$sharedManager;
}
var $2a31db1208c463c9$export$2e2bcd8739ae039 = $2a31db1208c463c9$var$BootstrapModalManager;



var $ih19M = parcelRequire("ih19M");
"use client";
function $a7721359ffb4c0e7$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e99d6b9e7fb9c6ac$export$2e2bcd8739ae039), {
        ...props
    });
}
function $a7721359ffb4c0e7$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $337c19c74a9003c2$export$2e2bcd8739ae039), {
        ...props
    });
}
const $a7721359ffb4c0e7$var$Offcanvas = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $bh6RR.useRef)();
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $bh6RR.useState)(false);
    const handleHide = (0, $f3b5e78021297094$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $c66f4a5529732302$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $bh6RR.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $bh6RR.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $2a31db1208c463c9$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $2a31db1208c463c9$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $bh6RR.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9e099960a76146bb$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a0abb309858b437e$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $a7721359ffb4c0e7$var$DialogTransition,
                    backdropTransition: $a7721359ffb4c0e7$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$a7721359ffb4c0e7$var$Offcanvas.displayName = 'Offcanvas';
var $a7721359ffb4c0e7$export$2e2bcd8739ae039 = Object.assign($a7721359ffb4c0e7$var$Offcanvas, {
    Body: (0, $289bed0efcf57119$export$2e2bcd8739ae039),
    Header: (0, $976fc9c8d19d1497$export$2e2bcd8739ae039),
    Title: (0, $eb64af4354022640$export$2e2bcd8739ae039)
});




var $ih19M = parcelRequire("ih19M");
"use client";
const $04ad3844ba07d592$var$NavbarOffcanvas = /*#__PURE__*/ $bh6RR.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $bh6RR.useContext)((0, $e87fe3fc2803189b$export$2e2bcd8739ae039));
    const handleHide = (0, $f3b5e78021297094$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $a7721359ffb4c0e7$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$04ad3844ba07d592$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $04ad3844ba07d592$export$2e2bcd8739ae039 = $04ad3844ba07d592$var$NavbarOffcanvas;



var $5ozxM = parcelRequire("5ozxM");


var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $5b1dc07eac9fbed9$var$NavbarText = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix),
        ...props
    });
});
$5b1dc07eac9fbed9$var$NavbarText.displayName = 'NavbarText';
var $5b1dc07eac9fbed9$export$2e2bcd8739ae039 = $5b1dc07eac9fbed9$var$NavbarText;



var $ih19M = parcelRequire("ih19M");
"use client";
const $009d538b735550b4$var$Navbar = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $94e0357acb68c07d$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $5ozxM.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $bh6RR.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $bh6RR.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $e87fe3fc2803189b$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a76d3643f5fa154$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$009d538b735550b4$var$Navbar.displayName = 'Navbar';
var $009d538b735550b4$export$2e2bcd8739ae039 = Object.assign($009d538b735550b4$var$Navbar, {
    Brand: (0, $c172ce2c4551a6fb$export$2e2bcd8739ae039),
    Collapse: (0, $ea601c8f500afd6f$export$2e2bcd8739ae039),
    Offcanvas: (0, $04ad3844ba07d592$export$2e2bcd8739ae039),
    Text: (0, $5b1dc07eac9fbed9$export$2e2bcd8739ae039),
    Toggle: (0, $59915c67ecadcd7d$export$2e2bcd8739ae039)
});



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $7db4dc08f494ed1d$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $bh6RR.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $bh6RR = parcelRequire("bh6RR");
const $001f72676e3ca26d$var$NavContext = /*#__PURE__*/ $bh6RR.createContext(null);
$001f72676e3ca26d$var$NavContext.displayName = 'NavContext';
var $001f72676e3ca26d$export$2e2bcd8739ae039 = $001f72676e3ca26d$var$NavContext;




var $bh6RR = parcelRequire("bh6RR");
const $c6f80e8e893e09fa$var$TabContext = /*#__PURE__*/ $bh6RR.createContext(null);
var $c6f80e8e893e09fa$export$2e2bcd8739ae039 = $c6f80e8e893e09fa$var$TabContext;




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
const $ef1c3b1036992476$var$_excluded = [
    "as",
    "disabled"
];
function $ef1c3b1036992476$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ef1c3b1036992476$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $ef1c3b1036992476$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $ef1c3b1036992476$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $ef1c3b1036992476$var$Button = /*#__PURE__*/ $bh6RR.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $ef1c3b1036992476$var$_objectWithoutPropertiesLoose(_ref, $ef1c3b1036992476$var$_excluded);
    const [buttonProps, { tagName: Component }] = $ef1c3b1036992476$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$ef1c3b1036992476$var$Button.displayName = 'Button';
var $ef1c3b1036992476$export$2e2bcd8739ae039 = $ef1c3b1036992476$var$Button;





var $ih19M = parcelRequire("ih19M");
const $55cc5e8728ff0df1$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $55cc5e8728ff0df1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $55cc5e8728ff0df1$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $bh6RR.useContext)((0, $2a76d3643f5fa154$export$2e2bcd8739ae039));
    const navContext = (0, $bh6RR.useContext)((0, $001f72676e3ca26d$export$2e2bcd8739ae039));
    const tabContext = (0, $bh6RR.useContext)((0, $c6f80e8e893e09fa$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $54e82c94c8a6341a$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $55cc5e8728ff0df1$var$NavItem = /*#__PURE__*/ $bh6RR.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $ef1c3b1036992476$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $55cc5e8728ff0df1$var$_objectWithoutPropertiesLoose(_ref, $55cc5e8728ff0df1$var$_excluded);
    const [props, meta] = $55cc5e8728ff0df1$export$d7a68693710982a(Object.assign({
        key: (0, $2a76d3643f5fa154$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $54e82c94c8a6341a$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$55cc5e8728ff0df1$var$NavItem.displayName = 'NavItem';
var $55cc5e8728ff0df1$export$2e2bcd8739ae039 = $55cc5e8728ff0df1$var$NavItem;



var $ih19M = parcelRequire("ih19M");
const $1c65688603410549$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $1c65688603410549$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $1c65688603410549$var$noop = ()=>{};
const $1c65688603410549$var$EVENT_KEY_ATTR = (0, $54e82c94c8a6341a$export$5cc3b7b83e34ade7)('event-key');
const $1c65688603410549$var$Nav = /*#__PURE__*/ $bh6RR.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $1c65688603410549$var$_objectWithoutPropertiesLoose(_ref, $1c65688603410549$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $7db4dc08f494ed1d$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $bh6RR.useRef)(false);
    const parentOnSelect = (0, $bh6RR.useContext)((0, $2a76d3643f5fa154$export$2e2bcd8739ae039));
    const tabContext = (0, $bh6RR.useContext)((0, $c6f80e8e893e09fa$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $bh6RR.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $f94b1ae4682370af$export$2e2bcd8739ae039)(currentListNode, `[${$1c65688603410549$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $54e82c94c8a6341a$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $bh6RR.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$1c65688603410549$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $c94e17ffa3b3dac8$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a76d3643f5fa154$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $001f72676e3ca26d$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $2a76d3643f5fa154$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $1c65688603410549$var$noop,
                getControllerId: getControllerId || $1c65688603410549$var$noop
            },
            children: /*#__PURE__*/ (0, $ih19M.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$1c65688603410549$var$Nav.displayName = 'Nav';
var $1c65688603410549$export$2e2bcd8739ae039 = Object.assign($1c65688603410549$var$Nav, {
    Item: (0, $55cc5e8728ff0df1$export$2e2bcd8739ae039)
});



var $5ozxM = parcelRequire("5ozxM");


var $bh6RR = parcelRequire("bh6RR");
"use client";
const $ac3efbe0c459d747$var$context = /*#__PURE__*/ $bh6RR.createContext(null);
$ac3efbe0c459d747$var$context.displayName = 'CardHeaderContext';
var $ac3efbe0c459d747$export$2e2bcd8739ae039 = $ac3efbe0c459d747$var$context;



var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");

var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $83136dbcb1243a15$var$NavItem = /*#__PURE__*/ $bh6RR.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix),
        ...props
    });
});
$83136dbcb1243a15$var$NavItem.displayName = 'NavItem';
var $83136dbcb1243a15$export$2e2bcd8739ae039 = $83136dbcb1243a15$var$NavItem;



var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $b1b568d4e029d55f$export$2e2bcd8739ae039() {
    return (0, $bh6RR.useState)(null);
}





var $bh6RR = parcelRequire("bh6RR");

function $dc348f317af24bad$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)(listener);
    (0, $bh6RR.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $bh6RR = parcelRequire("bh6RR");
function $8bc3844b57ff1a51$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $bh6RR.useCallback)(()=>document, []);
    return (0, $dc348f317af24bad$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $bh6RR = parcelRequire("bh6RR");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $9c681d1b1fd1bb9e$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $60bf0a902186ff6a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $60bf0a902186ff6a$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $9c681d1b1fd1bb9e$export$2e2bcd8739ae039 = $9c681d1b1fd1bb9e$var$useInterval;



var $bh6RR = parcelRequire("bh6RR");

function $677cc10a74bb38d4$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $60bf0a902186ff6a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $60bf0a902186ff6a$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $bh6RR.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $677cc10a74bb38d4$export$2e2bcd8739ae039 = $677cc10a74bb38d4$var$useRafInterval;



var $bh6RR = parcelRequire("bh6RR");
function $e3e0e07fe8455355$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $bh6RR.useState)(initialState);
    const updater = (0, $bh6RR.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $3733b20603ca3bb2$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $e3e0e07fe8455355$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $bh6RR = parcelRequire("bh6RR");
function $95276c066dc26455$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $bh6RR.useState)({
        image: null,
        error: null
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $bh6RR = parcelRequire("bh6RR");

const $889e4a3e96f09a53$var$targetMap = new WeakMap();
let $889e4a3e96f09a53$var$resizeObserver;
function $889e4a3e96f09a53$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $889e4a3e96f09a53$var$resizeObserver = $889e4a3e96f09a53$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $889e4a3e96f09a53$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $889e4a3e96f09a53$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $bh6RR.useState)(null);
    (0, $f8d239d2b60467d0$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $889e4a3e96f09a53$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $889e4a3e96f09a53$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $889e4a3e96f09a53$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $ih19M = parcelRequire("ih19M");
const $7ed724f9b8245818$var$_excluded = [
    "onKeyDown"
];
function $7ed724f9b8245818$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $7ed724f9b8245818$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $7ed724f9b8245818$var$Anchor = /*#__PURE__*/ $bh6RR.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $7ed724f9b8245818$var$_objectWithoutPropertiesLoose(_ref, $7ed724f9b8245818$var$_excluded);
    const [buttonProps] = (0, $ef1c3b1036992476$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $8b53c13614d6c8a4$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($7ed724f9b8245818$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $ih19M.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $ih19M.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$7ed724f9b8245818$var$Anchor.displayName = 'Anchor';
var $7ed724f9b8245818$export$2e2bcd8739ae039 = $7ed724f9b8245818$var$Anchor;





var $5ozxM = parcelRequire("5ozxM");

var $ih19M = parcelRequire("ih19M");
"use client";
const $fa58ecc43c1e3959$var$NavLink = /*#__PURE__*/ $bh6RR.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $7ed724f9b8245818$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $5ozxM.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $55cc5e8728ff0df1$export$d7a68693710982a)({
        key: (0, $2a76d3643f5fa154$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$fa58ecc43c1e3959$var$NavLink.displayName = 'NavLink';
var $fa58ecc43c1e3959$export$2e2bcd8739ae039 = $fa58ecc43c1e3959$var$NavLink;



var $ih19M = parcelRequire("ih19M");
"use client";
const $208d25fd81f13ee4$var$Nav = /*#__PURE__*/ $bh6RR.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $94e0357acb68c07d$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $5ozxM.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $bh6RR.useContext)((0, $e87fe3fc2803189b$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $bh6RR.useContext)((0, $ac3efbe0c459d747$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $1c65688603410549$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$208d25fd81f13ee4$var$Nav.displayName = 'Nav';
var $208d25fd81f13ee4$export$2e2bcd8739ae039 = Object.assign($208d25fd81f13ee4$var$Nav, {
    Item: (0, $83136dbcb1243a15$export$2e2bcd8739ae039),
    Link: (0, $fa58ecc43c1e3959$export$2e2bcd8739ae039)
});



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
const $95cf7b771e640ce2$var$HeFooter = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("footer", {
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "col-lg-8 col-md-10 mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                            className: "list-inline text-center",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    className: "list-inline-item",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                            className: "fa-stack fa-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fas fa-circle fa-stack-2x"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fab fa-twitter fa-stack-1x fa-inverse"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    className: "list-inline-item",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                            className: "fa-stack fa-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fas fa-circle fa-stack-2x"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fab fa-facebook-f fa-stack-1x fa-inverse"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                    className: "list-inline-item",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                            className: "fa-stack fa-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fas fa-circle fa-stack-2x"
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("i", {
                                                    className: "fab fa-github fa-stack-1x fa-inverse"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                            className: "text-center",
                            children: [
                                "                    ",
                                /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                    href: "mailto:inna@light-eng.com",
                                    children: "inna@light-eng.com"
                                }),
                                " 0544-236006            "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "copyright text-muted",
                            children: "Copyright \xa9 IBN Labs Ltb 2019"
                        })
                    ]
                })
            })
        })
    });
};
var $95cf7b771e640ce2$export$2e2bcd8739ae039 = $95cf7b771e640ce2$var$HeFooter;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $02bf45b3d71c1dbb$var$About extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    children: "\u05E2\u05DC\u05D9\u05E0\u05D5"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05DE\u05E2\u05D1\u05D3\u05D5\u05EA \u05E0\u05D5\u05E1\u05D3\u05D4 \u05D1 2010 \u05D1\u05DE\u05D8\u05E8\u05D4 \u05DC\u05E2\u05E0\u05D5\u05EA \u05E2\u05DC \u05D4\u05E6\u05D5\u05E8\u05DA \u05D1\u05DE\u05EA\u05DF \u05E9\u05D9\u05E8\u05D5\u05EA\u05D9\u05DD \u05D1\u05E7\u05E8\u05D4 \u05D5\u05E4\u05D9\u05E7\u05D5\u05D7 \u05D0\u05D9\u05DB\u05D5\u05EA \u05DC\u05EA\u05D0\u05D5\u05E8\u05D4."
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: ".\u05DC\u05DE\u05E2\u05D1\u05D3\u05D4 \u05D4\u05E1\u05DE\u05DB\u05D4 ISO17025 \u05D1\u05E4\u05D9\u05E7\u05D5\u05D7 \u05D4\u05E8\u05E9\u05D5\u05EA \u05D4\u05DC\u05D0\u05D5\u05DE\u05D9\u05EA \u05DC\u05D4\u05E1\u05DE\u05DB\u05EA \u05DE\u05E2\u05D1\u05D3\u05D5\u05EA"
                }),
                '\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05D4\u05D9\u05D0 \u05DE\u05E2\u05D1\u05D3\u05D4 \u05DE\u05D5\u05E1\u05DE\u05DB\u05EA ISO17025 \u05DC\u05D1\u05D9\u05E6\u05D5\u05E2 \u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05EA\u05D0\u05D5\u05E8\u05D4 \u05D5\u05E6\u05D9\u05D5\u05D3 \u05E9\u05D9\u05E8\u05D5\u05EA\u05D9 \u05D4\u05DE\u05E2\u05D1\u05D3\u05D4 \u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05EA\u05D0\u05D5\u05E8\u05D4 \u05D1\u05D0\u05EA\u05E8\u05D9\u05DD \u05DE\u05D2\u05D5\u05D5\u05E0\u05D9\u05DD \u05DB\u05D1\u05D9\u05E9\u05D9\u05DD - \u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05D4\u05D0\u05E8\u05D4 \u05D5\u05D1\u05D4\u05D9\u05E7\u05D5\u05EA, \u05D1\u05D7\u05D9\u05E0\u05EA \u05E2\u05DE\u05D9\u05D3\u05D4 \u05D1\u05EA"\u05D9 13201, \u05EA"\u05D9 1862  \u05D5\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05EA\u05DB\u05E0\u05D5\u05DF \u05EA\u05D0\u05D5\u05E8\u05EA \u05E4\u05E0\u05D9\u05DD - \u05EA"\u05D9 12464 \u05D7\u05DC\u05E7 1 \u05EA\u05D0\u05D5\u05E8\u05EA \u05D7\u05D5\u05E5- \u05EA"\u05D9 12464 \u05D7\u05DC\u05E7 2 \u05EA\u05D0\u05D5\u05E8\u05EA \u05D7\u05D9\u05E8\u05D5\u05DD \u05D5\u05D4\u05DB\u05D5\u05D5\u05E0\u05D4- \u05EA\u05E7\u05E0\u05D5\u05EA \u05D4\u05D1\u05E0\u05D9\u05D4 \u05D5\u05EA"\u05D9 1838 \u05EA\u05D0\u05D5\u05E8\u05EA \u05DE\u05EA\u05E7\u05E0\u05D9 \u05E1\u05E4\u05D5\u05E8\u05D8 - \u05D3\u05E8\u05D9\u05E9\u05D5\u05EA FIFA ,UEFA , FIBA \u05D5\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05D2\u05D5\u05E4\u05D9\u05DD \u05E8\u05DC\u05D5\u05D5\u05E0\u05D8\u05D9\u05D9\u05DD \u05D1\u05D9\u05E9\u05E8\u05D0\u05DC \u05DE\u05E0\u05D4\u05E8\u05D5\u05EA - \u05EA\u05D0\u05D5\u05E8\u05EA \u05D7\u05D9\u05E8\u05D5\u05DD \u05D5\u05D4\u05DB\u05D5\u05D5\u05E0\u05D4 \u05D6\u05D9\u05D4\u05D5\u05DD \u05D0\u05D5\u05E8\u05D9 \u05D5\u05D0\u05D5\u05E8 \u05E4\u05D5\u05DC\u05E9 - \u05EA\u05E7\u05E0\u05D9\u05DD CIE150 , \u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05E8\u05D8"\u05D2 \u05E1\u05E4\u05E7\u05D8\u05E8\u05D5\u05DD \u05D5\u05E0\u05D9\u05EA\u05D5\u05D7 - CCT, \u05D9\u05D7\u05E1 \u05E8\u05DB\u05D9\u05D1\u05D9\u05DD, \u05EA\u05DB\u05D5\u05DC\u05EA \u05E7\u05E8\u05D9\u05E0\u05D4 \u05E7\u05E6\u05E8\u05EA \u05D2\u05DC Blue Hazard  \u05D5\u05E2\u05D5\u05D3 \u05D4\u05D1\u05D4\u05D5\u05D1 \u05D7\u05E9\u05DE\u05DC\u05D9 \u05D5\u05D0\u05D5\u05E4\u05D8\u05D9 \u05D1\u05D3\u05D9\u05E7\u05EA \u05E6\u05D9\u05D5\u05D3 \u05D5\u05E1\u05D1\u05D9\u05D1\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4 \u05D1\u05D8\u05D9\u05D7\u05D5\u05EA \u05E4\u05D5\u05D8\u05D5\u05D1\u05D9\u05D5\u05DC\u05D5\u05D2\u05D9\u05EA - Blue Hazard , \u05EA"\u05D9 62471 (\u05DB\u05D5\u05DC\u05DC \u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05EA"\u05D9 20 62778) \u05E1\u05E4\u05E7\u05D8\u05E8\u05D5\u05DD \u05E9\u05DC \u05D2\u05D5\u05E4\u05D9 \u05EA\u05D0\u05D5\u05E8\u05D4 \u05D4\u05D1\u05D4\u05D5\u05D1 IEEE1789 \u05E9\u05D9\u05DC\u05D5\u05D8 \u05D5\u05E1\u05D9\u05DE\u05D5\u05DF - \u05EA"\u05D9 20 - 22 \u05E1\u05D9\u05DB\u05D5\u05E0\u05D9 UV, \u05E6\u05D9\u05D5\u05D3 \u05D5\u05DE\u05D9\u05D2\u05D5\u05DF \u05D1\u05DE\u05E7\u05D5\u05DE\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4 \u05DC\u05E4\u05D9 \u05D4\u05E0\u05D7\u05D9\u05D5\u05EA ICNIRP OSHA IEC62471 \u05D5\u05E0\u05D4\u05DC\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05D9\u05DD \u05DC\u05D9\u05D5\u05D5\u05D9 \u05E4\u05E8\u05D5\u05D9\u05E7\u05D8\u05D9\u05DD \u05D5\u05EA\u05D4\u05DC\u05D9\u05DB\u05D9 \u05E8\u05DB\u05E9 \u05D4\u05D2\u05D3\u05E8\u05EA \u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05D1\u05D4\u05EA\u05D0\u05DD \u05DC\u05EA\u05E7\u05E0\u05D9\u05DD \u05D5\u05DC\u05E4\u05D9 \u05E6\u05E8\u05DB\u05D9 \u05D4\u05DC\u05E7\u05D5\u05D7 \u05D9\u05D9\u05E2\u05D5\u05E5 \u05D8\u05DB\u05E0\u05D9 \u05D1\u05E7\u05D1\u05D9\u05E2\u05EA \u05DE\u05D3\u05D9\u05E0\u05D9\u05D5\u05EA \u05DB\u05DC\u05DC\u05D9\u05EA \u05DB\u05EA\u05D9\u05D1\u05EA \u05DE\u05E4\u05E8\u05D8\u05D9\u05DD \u05D8\u05DB\u05E0\u05D9\u05D9\u05DD \u05E0\u05D9\u05EA\u05D5\u05D7 \u05D8\u05DB\u05E0\u05D5-\u05DB\u05DC\u05DB\u05DC\u05D9 \u05DC\u05D7\u05D9\u05E1\u05DB\u05D5\u05DF \u05D1\u05D0\u05E0\u05E8\u05D2\u05D9\u05D4 \u05D1\u05D7\u05D9\u05E0\u05EA \u05D4\u05EA\u05D0\u05DE\u05D4 \u05E9\u05DC \u05E6\u05D9\u05D5\u05D3 \u05DC\u05DE\u05E4\u05E8\u05D8 \u05D5\u05D1\u05DB\u05DC\u05DC \u05D6\u05D4 \u05D1\u05D3\u05D9\u05E7\u05D4 \u05DE\u05E7\u05E6\u05D5\u05E2\u05D9\u05EA \u05E9\u05DC \u05DE\u05E1\u05DE\u05DB\u05D9\u05DD \u05D5\u05EA\u05D9\u05E2\u05D5\u05D3 \u05D4\u05E6\u05D9\u05D5\u05D3 \u05D1\u05D3\u05D9\u05E7\u05EA \u05D1\u05D9\u05E6\u05D5\u05E2 - \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05D5\u05EA\u05DB\u05E0\u05D5\u05DF \u05D4\u05D3\u05E8\u05DB\u05D4 \u05D9\u05DE\u05D9 \u05E2\u05D9\u05D5\u05DF \u05D5\u05E7\u05D5\u05E8\u05E1\u05D9\u05DD \u05D1\u05E0\u05D5\u05E9\u05D0\u05D9 \u05EA\u05D0\u05D5\u05E8\u05D4 \u05D4\u05D3\u05E8\u05DB\u05D4 \u05DB\u05D7\u05DC\u05E7 \u05DE\u05DE\u05D3\u05D9\u05E0\u05D9\u05D5\u05EA \u05DE\u05E4\u05E2\u05DC\u05D9\u05EA \u05DC\u05D4\u05D2\u05D1\u05E8\u05EA \u05DE\u05D5\u05D3\u05E2\u05D5\u05EA \u05DC\u05E1\u05D9\u05DB\u05D5\u05E0\u05D9\u05DD \u05D1\u05E0\u05D5\u05E1\u05E3, \u05DC\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05D9\u05DB\u05D5\u05DC\u05D5\u05EA \u05DC\u05E4\u05D9\u05EA\u05D5\u05D7 \u05E9\u05D9\u05D8\u05D5\u05EA \u05DE\u05D3\u05D9\u05D3\u05D4 \u05D9\u05E2\u05D5\u05D3\u05D9\u05D5\u05EA \u05D1\u05E0\u05D5\u05E9\u05D0\u05D9\u05DD \u05E9\u05D5\u05E0\u05D9\u05DD \u05D5\u05D1\u05D8\u05DB\u05E0\u05D5\u05DC\u05D5\u05D2\u05D9\u05D5\u05EA \u05E2\u05D3\u05DB\u05E0\u05D9\u05D5\u05EA - \u05D1\u05D4\u05EA\u05D0\u05DD \u05DC\u05E6\u05E8\u05DB\u05D9\u05DD \u05D5\u05DC\u05EA\u05E7\u05E0\u05D9\u05DD \u05D4\u05E8\u05DC\u05D5\u05E0\u05D8\u05D9\u05D9\u05DD. \u05E0\u05D9\u05D4\u05D5\u05DC \u05D4\u05DE\u05E2\u05D1\u05D3\u05D4 \u05D1\u05E0\u05D9\u05D4\u05D5\u05DC\u05D4 \u05E9\u05DC \u05D3"\u05E8 \u05D0\u05D9\u05E0\u05D4 \u05E0\u05D9\u05E1\u05E0\u05D1\u05D0\u05D5\u05DD, \u05DE\u05D4\u05E0\u05D3\u05E1\u05EA \u05D7\u05E9\u05DE\u05DC \u05D5\u05D0\u05DC\u05E7\u05D8\u05E8\u05D5\u05E0\u05D9\u05E7\u05D4 \u05D0\u05E9\u05E8 \u05D4\u05EA\u05DE\u05D7\u05EA\u05D4 \u05D1\u05DC\u05D9\u05DE\u05D5\u05D3\u05D9 \u05D4\u05E0\u05D3\u05E1\u05D4 (\u05EA\u05D5\u05D0\u05E8 \u05E8\u05D0\u05E9\u05D5\u05DF, \u05E9\u05E0\u05D9 \u05D5\u05E9\u05DC\u05D9\u05E9\u05D9) \u05D5\u05DC\u05D9\u05DE\u05D5\u05D3\u05D9 \u05D0\u05E0\u05E8\u05D2\u05D9\u05D4 \u05D1\u05D0\u05D5\u05E0\u05D9\u05D1\u05E8\u05E1\u05D9\u05D8\u05EA \u05EA\u05DC \u05D0\u05D1\u05D9\u05D1. \u05D3"\u05E8 \u05E0\u05D9\u05E1\u05E0\u05D1\u05D0\u05D5\u05DD \u05D1\u05E2\u05DC\u05EA \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05E2\u05E9\u05D9\u05E8 \u05D1\u05EA\u05D0\u05D5\u05E8\u05D4 \u05D5\u05D1\u05DB\u05DC\u05DC \u05D6\u05D4 \u05D9\u05D9\u05E2\u05D5\u05E5 \u05D5\u05EA\u05DB\u05E0\u05D5\u05DF \u05D1\u05DE\u05D0\u05D5\u05EA \u05E4\u05E8\u05D5\u05D9\u05E7\u05D8\u05D9\u05DD, \u05D5\u05D9\u05D9\u05E2\u05D5\u05E5 \u05D1\u05DE\u05D5\u05E1\u05D3\u05D5\u05EA \u05E9\u05D5\u05E0\u05D9\u05DD: \u05DE\u05E9\u05E8\u05D3 \u05D4\u05D1\u05D9\u05D8\u05D7\u05D5\u05DF, \u05DE\u05E9\u05E8\u05D3 \u05D4\u05D1\u05E8\u05D9\u05D0\u05D5\u05EA, \u05DE\u05E9\u05E8\u05D3 \u05D4\u05E2\u05D1\u05D5\u05D3\u05D4, \u05DE\u05E9\u05E8\u05D3 \u05D4\u05EA\u05E9\u05EA\u05D9\u05D5\u05EA \u05D4\u05DC\u05D0\u05D5\u05DE\u05D9\u05D5\u05EA, \u05DE\u05E9\u05E8\u05D3 \u05D4\u05DB\u05DC\u05DB\u05DC\u05D4, \u05E9\u05E8\u05D5\u05EA\u05D9 \u05D1\u05E8\u05D9\u05D0\u05D5\u05EA \u05DB\u05DC\u05DC\u05D9\u05EA, \u05E8\u05E9\u05D5\u05EA \u05E9\u05D3\u05D5\u05EA \u05D4\u05EA\u05E2\u05D5\u05E4\u05D4, \u05E2\u05D9\u05E8\u05D9\u05D5\u05EA, \u05E8\u05E9\u05D5\u05D9\u05D5\u05EA \u05D5\u05DE\u05D5\u05E2\u05E6\u05D5\u05EA \u05E8\u05D1\u05D5\u05EA, \u05D1\u05E0\u05E7\u05D9\u05DD, \u05E8\u05E9\u05EA \u05E1\u05D5\u05E4\u05E8\u05E4\u05D0\u05E8\u05DD \u05D5\u05E2\u05D5\u05D3. \u05D3"\u05E8 \u05E0\u05D9\u05E1\u05E0\u05D1\u05D0\u05D5\u05DD \u05DE\u05E9\u05EA\u05EA\u05E4\u05EA \u05D1\u05E4\u05E2\u05D9\u05DC\u05D5\u05EA \u05EA\u05E7\u05D9\u05E0\u05D4, \u05D1\u05D4\u05DB\u05E0\u05EA\u05DD \u05E9\u05DC \u05EA\u05E7\u05E0\u05D5\u05EA \u05D5\u05EA\u05E7\u05E0\u05D9 \u05EA\u05D0\u05D5\u05E8\u05D4 \u05E9\u05D5\u05E0\u05D9\u05DD,  \u05DE\u05E8\u05E6\u05D4 \u05DC\u05EA\u05D0\u05D5\u05E8\u05D4 \u05D1\u05D0\u05D5\u05E0\u05D9\u05D1\u05E8\u05E1\u05D9\u05D8\u05EA \u05EA\u05DC \u05D0\u05D1\u05D9\u05D1, \u05D4\u05DE\u05D5\u05E1\u05D3 \u05DC\u05D1\u05D8\u05D9\u05D7\u05D5\u05EA \u05D5\u05DC\u05D2\u05D9\u05D4\u05D5\u05EA \u05D5\u05E2\u05D5\u05D3. \u05DB\u05DE\u05D5 \u05DB\u05DF, \u05D4\u05D9\u05D0 \u05E8\u05E9\u05D5\u05DE\u05D4 \u05D1\u05E8\u05E9\u05D9\u05DE\u05EA \u05D4\u05D7\u05D1\u05E8\u05D5\u05EA \u05D4\u05DE\u05D5\u05DE\u05DC\u05E6\u05D5\u05EA \u05E2"\u05D9 \u05DE\u05E9\u05E8\u05D3 \u05D4\u05EA\u05E9\u05EA\u05D9\u05D5\u05EA \u05DC\u05D1\u05D9\u05E6\u05D5\u05E2 \u05E1\u05E7\u05E8\u05D9 \u05D0\u05E0\u05E8\u05D2\u05D9\u05D4. \u05D3"\u05E8 \u05D0\u05D9\u05E0\u05D4 \u05E0\u05D9\u05E1\u05E0\u05D1\u05D0\u05D5\u05DD \u05D9\u05D5\u05E9\u05D1\u05EA \u05E8\u05D0\u05E9 \u05E9\u05DC \u05D4\u05D0\u05D2\u05D5\u05D3\u05D4 \u05D4\u05D9\u05E9\u05E8\u05D0\u05DC\u05D9\u05EA \u05DC\u05EA\u05D0\u05D5\u05E8\u05D4, \u05D7\u05D1\u05E8\u05EA \u05D1\u05D4\u05E0\u05D4\u05DC\u05EA \u05E2\u05E0\u05E3 \u05D7\u05E9\u05DE\u05DC \u05D5\u05D0\u05DC\u05E7\u05D8\u05E8\u05D5\u05E0\u05D9\u05E7\u05D4 \u05D1\u05DC\u05E9\u05DB\u05EA \u05D4\u05DE\u05D4\u05E0\u05D3\u05E1\u05D9\u05DD \u05D5\u05D4\u05D0\u05D3\u05E8\u05D9\u05DB\u05DC\u05D9\u05DD \u05D5\u05D7\u05D1\u05E8\u05D4 \u05D3\u05D9\u05E8\u05E7\u05D8\u05D5\u05E8\u05D9\u05D5\u05DF \u05DE\u05DB\u05D5\u05DF \u05D4\u05EA\u05E7\u05E0\u05D9\u05DD \u05D4\u05D9\u05E9\u05E8\u05D0\u05DC\u05D9.',
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "\u05D4\u05DE\u05E2\u05D1\u05D3\u05D4 \u05DE\u05E6\u05D9\u05E2\u05D4 \u05E9\u05D9\u05E8\u05D5\u05EA\u05D9 \u05D1\u05D3\u05D9\u05E7\u05D4 \u05D5\u05D7\u05D5\u05D5\u05EA \u05D3\u05E2\u05EA \u05DE\u05D5\u05E1\u05DE\u05DB\u05EA "
                })
            ]
        });
    }
}
var $02bf45b3d71c1dbb$export$2e2bcd8739ae039 = $02bf45b3d71c1dbb$var$About;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $faa5a36779f74bc4$var$Services extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                    children: "\u05E9\u05E8\u05D5\u05EA\u05D9\u05DD"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                    children: "\u05D1\u05D3\u05D9\u05E7\u05D5\u05EA \u05E6\u05D9\u05D5\u05D3"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05D1\u05D3\u05D9\u05E7\u05D5\u05EA \u05D9\u05D1\u05D5\u05D0 \u05D5\u05EA\u05D0\u05D9\u05DE\u05D5\u05EA \u05D1\u05D3\u05D9\u05E7\u05EA \u05D2\u05D5\u05E4\u05D9 \u05EA\u05D0\u05D5\u05E8\u05D4 \u05D5\u05E6\u05D9\u05D5\u05D3 \u05DC\u05E2\u05DE\u05D9\u05D3\u05D4 \u05D1\u05EA\u05E7\u05E0\u05D9\u05DD, \u05DE\u05E4\u05E8\u05D8\u05D9\u05DD \u05D5\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: '\u05D1\u05D8\u05D9\u05D7\u05D5\u05EA \u05E4\u05D5\u05D8\u05D5\u05D1\u05D9\u05D5\u05DC\u05D5\u05D2\u05D9\u05EA - \u05EA"\u05D9 62471, \u05EA"\u05D9 62778'
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: " \u05E1\u05E4\u05E7\u05D8\u05E8\u05D5\u05DD \u05D0\u05D5\u05E8 SPD, \u05DE\u05E7\u05D3\u05DD \u05D4\u05E2\u05D1\u05E8\u05EA \u05E6\u05D1\u05E2 CRI, \u05D8\u05DE\u05E4\u05E8\u05D8\u05D5\u05E8\u05EA \u05E6\u05D1\u05E2 CCT "
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05D1\u05D4\u05D5\u05D1 - Flicker IEEE 1789"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05DE\u05E4\u05E8\u05D8 \u05D1\u05D9\u05E0\u05DE\u05E9\u05E8\u05D3\u05D9 08"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05D9\u05D9\u05E2\u05D5\u05E5 \u05D5\u05DB\u05EA\u05D9\u05D1\u05EA \u05DE\u05E4\u05E8\u05D8\u05D9\u05DD"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05DB\u05EA\u05D9\u05D1\u05EA \u05DE\u05E4\u05E8\u05D8\u05D9\u05DD \u05D8\u05DB\u05E0\u05D9\u05D9\u05DD"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E9\u05DC \u05D4\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05DC\u05EA\u05E7\u05E0\u05D9\u05DD \u05D5\u05DC\u05EA\u05E7\u05E0\u05D5\u05EA"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05E9\u05DC \u05D4\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05DC\u05D0\u05D5\u05E4\u05D9 \u05D4\u05DE\u05EA\u05E7\u05DF, \u05E6\u05E8\u05DB\u05D9\u05DD \u05D8\u05DB\u05E0\u05D9\u05D9\u05DD \u05D5\u05D0\u05D3\u05E8\u05D9\u05DB\u05DC\u05D9\u05D9\u05DD"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05E8\u05E9\u05D5\u05D9\u05D5\u05EA"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05EA\u05E7\u05E6\u05D9\u05D1 \u05D5\u05D0\u05D9\u05DC\u05D5\u05E6\u05D9 \u05D4\u05E4\u05E8\u05D5\u05D9\u05D9\u05E7\u05D8"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05D1\u05D3\u05D9\u05E7\u05D5\u05EA \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05DE\u05E4\u05E8\u05D8\u05D9\u05DD"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D1\u05D7\u05D9\u05E0\u05EA \u05DE\u05E1\u05DE\u05DB\u05D9 \u05D4\u05D2\u05E9\u05D4 \u05D5\u05EA\u05E2\u05D5\u05D3\u05D5\u05EA \u05D1\u05D3\u05D9\u05E7\u05D4"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D9\u05D9\u05E2\u05D5\u05E5 \u05DC\u05D5\u05D5\u05E2\u05D3\u05EA \u05DE\u05DB\u05E8\u05D6\u05D9\u05DD \u05D5\u05D7\u05D5\u05D5\u05EA \u05D3\u05E2\u05EA"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "\u05D1\u05D3\u05D9\u05E7\u05EA \u05E6\u05D9\u05D5\u05D3 \u05D5\u05D1\u05D3\u05D9\u05E7\u05EA \u05DE\u05E1\u05DE\u05DB\u05D9\u05DD \u05E0\u05DC\u05D5\u05D9\u05DD \u05DE\u05D1\u05D7\u05D9\u05E0\u05EA \u05E2\u05DE\u05D9\u05D3\u05D4 \u05E9\u05DC \u05D4\u05E6\u05D9\u05D5\u05D3 \u05D1\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05DC\u05D0\u05D5\u05E8\u05DA \u05D6\u05DE\u05DF. \u05DC\u05E8\u05D1\u05D5\u05EA \u05EA\u05E0\u05D0\u05D9 \u05D0\u05D7\u05E8\u05D9\u05D5\u05EA \u05D9\u05E6\u05E8\u05DF \u05D1\u05D9\u05E9\u05E8\u05D0\u05DC, \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05DE\u05D9\u05E7\u05D5\u05DD \u05D4\u05EA\u05E7\u05E0\u05D4 \u05D1\u05EA\u05E0\u05D0\u05D9 \u05DE\u05D6\u05D2 \u05D4\u05D0\u05D5\u05D9\u05E8 \u05D1\u05D0\u05E8\u05E5. \u05D0\u05D5\u05E8\u05DA \u05D7\u05D9\u05D9\u05DD \u05DE\u05D5\u05E6\u05D4\u05E8, \u05D5\u05E2\u05D5\u05D3"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {}),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {}),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: " \u05DE\u05D3\u05D9\u05D3\u05EA \u05DE\u05EA\u05E7\u05E0\u05D9 \u05EA\u05D0\u05D5\u05E8\u05EA \u05E4\u05E0\u05D9\u05DD \u05D5\u05D7\u05D5\u05E5"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: ' \u05D1\u05E0\u05D9\u05D4 \u05D9\u05E8\u05D5\u05E7\u05D4 - \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05EA\u05D0\u05D5\u05E8\u05D4 \u05EA"\u05D9 5281'
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: ' \u05D7\u05D9\u05E1\u05DB\u05D5\u05DF \u05D1\u05D0\u05E0\u05E8\u05D2\u05D9\u05D4 \u05D1\u05EA\u05D0\u05D5\u05E8\u05D4 - \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05EA\u05D0\u05D5\u05E8\u05D4 \u05EA"\u05D9 5280'
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05D6\u05D9\u05D4\u05D5\u05DD \u05D0\u05D5\u05E8"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: '\u05D0\u05D5\u05E8 \u05E4\u05D5\u05DC\u05E9 \u05D5\u05E2\u05DE\u05D9\u05D3\u05D4 \u05D1\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05E9\u05DE\u05D9\u05E8\u05D4 \u05E2\u05DC \u05D4\u05D8\u05D1\u05E2 , \u05DE\u05E0\u05D9\u05E2\u05EA \u05D6\u05D9\u05D4\u05D5\u05DD \u05D0\u05D5\u05E8\u05D9 \u05D5\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA \u05E8\u05D8"\u05D2'
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05DE\u05E0\u05D9\u05E2\u05EA \u05D0\u05D5\u05E8 \u05E4\u05D5\u05DC\u05E9\u05E0\u05D9 \u05DE\u05EA\u05D0\u05D5\u05E8\u05EA \u05D7\u05D5\u05E5 - CIE150"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05DB\u05D1\u05D9\u05E9\u05D9\u05DD \u05D5\u05DE\u05E0\u05D4\u05E8\u05D5\u05EA"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        children: "\u05D0\u05D9\u05DB\u05D5\u05EA \u05D4\u05D0\u05E8\u05D4 \u05DC\u05E4\u05D9 \u05EA\"' 13201 \u05D5\u05EA\u05E7\u05E0\u05D9\u05DD \u05E8\u05DC\u05D5\u05E0\u05D8\u05D9\u05D9\u05DD \u05DC\u05DE\u05EA\u05E7\u05DF"
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05DE\u05EA\u05E7\u05E0\u05D9 \u05E1\u05E4\u05D5\u05E8\u05D8"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05EA\u05D0\u05D5\u05E8\u05EA \u05D7\u05D9\u05E8\u05D5\u05DD \u05D5\u05DE\u05D9\u05DC\u05D5\u05D8"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                    children: "\u05EA\u05D0\u05D5\u05E8\u05EA \u05E4\u05E0\u05D9\u05DD"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                    children: "\u05D1\u05D8\u05D9\u05D7\u05D5\u05EA \u05E7\u05E8\u05D9\u05E0\u05D4 \u05D0\u05D5\u05DC\u05D8\u05E8\u05D4 \u05E1\u05D2\u05D5\u05DC\u05D4 UV  "
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "\u05E1\u05E7\u05E8 \u05DE\u05E4\u05E2\u05DC\u05D9 - \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA UV \u05D5\u05E6\u05D9\u05D5\u05D3 \u05D4\u05D2\u05E0\u05D4"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                    children: "\u05D4\u05D3\u05E8\u05DB\u05D4"
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D9\u05DE\u05D9 \u05E2\u05D9\u05D5\u05DF \u05D5\u05E1\u05D3\u05E0\u05D0\u05D5\u05EA \u05DE\u05E7\u05E6\u05D5\u05E2\u05D9\u05D5\u05EA"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            children: "\u05D4\u05D3\u05E8\u05DB\u05D5\u05EA \u05D9\u05D6\u05D5\u05DE\u05D5\u05EA - \u05DE\u05E7\u05D5\u05DE\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4"
                        })
                    ]
                })
            ]
        });
    }
}
var $faa5a36779f74bc4$export$2e2bcd8739ae039 = $faa5a36779f74bc4$var$Services;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $b66f2c7682c2ec23$var$Contact extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            children: /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                children: "\u05D9\u05E6\u05D9\u05E8\u05EA \u05E7\u05E9\u05E8"
            })
        });
    }
}
var $b66f2c7682c2ec23$export$2e2bcd8739ae039 = $b66f2c7682c2ec23$var$Contact;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $f891885d951d1681$var$Home extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    children: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05DE\u05E1\u05E4\u05E7\u05EA \u05E9\u05D9\u05E8\u05D5\u05EA\u05D9 \u05DE\u05D3\u05D9\u05D3\u05D4 \u05D5\u05D1\u05D3\u05D9\u05E7\u05EA \u05D0\u05D9\u05DB\u05D5\u05EA \u05DC\u05D9\u05D1\u05D5\u05D0\u05E0\u05D9\u05DD \u05D5\u05DC\u05E6\u05E8\u05DB\u05E0\u05D9 \u05EA\u05D0\u05D5\u05E8\u05D4"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "col-sm",
                                children: "\u05DE\u05E2\u05D1\u05D3\u05EA \u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05DE\u05D5\u05E1\u05DE\u05DB\u05EA ISO17025 \u05D1\u05D3\u05D9\u05E7\u05D5\u05EA \u05E6\u05D9\u05D5\u05D3 \u05D5\u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05DE\u05EA\u05E7\u05E0\u05D9\u05DD \u05D1\u05D0\u05EA\u05E8 \u05D4\u05DC\u05E7\u05D5\u05D7"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "col-sm",
                                children: "\u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05E2\u05E9\u05D9\u05E8 \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05EA\u05D4\u05DC\u05D9\u05DB\u05D9 \u05E8\u05DB\u05E9: \u05D0\u05E4\u05D9\u05D5\u05DF, \u05D4\u05EA\u05D0\u05DE\u05D4 \u05DC\u05EA\u05E7\u05E0\u05D9\u05DD \u05D5\u05D3\u05E8\u05D9\u05E9\u05D5\u05EA, \u05D1\u05D3\u05D9\u05E7\u05EA \u05DE\u05DB\u05E8\u05D6\u05D9\u05DD, \u05D1\u05D3\u05D9\u05E7\u05D5\u05EA \u05D1\u05D9\u05E6\u05D5\u05E2"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "col-sm",
                                children: "\u05E9\u05D9\u05E8\u05D5\u05EA\u05D9\u05DD \u05DE\u05E9\u05DC\u05D9\u05DE\u05D9\u05DD: \u05D4\u05D3\u05E8\u05DB\u05D4, \u05E4\u05D9\u05EA\u05D5\u05D7 \u05DE\u05D3\u05D9\u05D3\u05D5\u05EA \u05D5\u05E9\u05D9\u05D8\u05D5\u05EA \u05DE\u05D3\u05D9\u05D3\u05D4, \u05D9\u05D9\u05E2\u05D5\u05E5 \u05D1\u05E2\u05E0\u05D9\u05D9\u05E0\u05D9 \u05EA\u05E7\u05D9\u05E0\u05D4 \u05D5\u05DE\u05D3\u05D9\u05E0\u05D9\u05D5\u05EA"
                            })
                        ]
                    })
                }),
                "        "
            ]
        });
    }
}
var $f891885d951d1681$export$2e2bcd8739ae039 = $f891885d951d1681$var$Home;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $73dec04020112de9$var$NoMatchHe extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            children: /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                children: "\u05D3\u05E3 \u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0"
            })
        });
    }
}
var $73dec04020112de9$export$2e2bcd8739ae039 = $73dec04020112de9$var$NoMatchHe;





var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
class $7094aa3258de9926$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, errorInfo);
        console.log(error, errorInfo);
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
            children: "Something went wrong."
        });
        return this.props.children;
    }
}
var $7094aa3258de9926$export$2e2bcd8739ae039 = $7094aa3258de9926$var$ErrorBoundary;


const $cc061bb11712ea3a$var$baseUrl = '' // '/ibn'
;
const $cc061bb11712ea3a$var$homeUrl = $cc061bb11712ea3a$var$baseUrl + '/';
const $cc061bb11712ea3a$var$anonymous_pages = [
    {
        url: '/',
        title: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA",
        component: (0, $f891885d951d1681$export$2e2bcd8739ae039)
    },
    {
        url: '/contact',
        title: "\u05D9\u05E6\u05D9\u05E8\u05EA \u05E7\u05E9\u05E8",
        component: (0, $b66f2c7682c2ec23$export$2e2bcd8739ae039)
    },
    {
        url: '/services',
        title: "\u05E9\u05E8\u05D5\u05EA\u05D9\u05DD",
        component: (0, $faa5a36779f74bc4$export$2e2bcd8739ae039)
    },
    {
        url: '/about',
        title: "\u05E2\u05DC\u05D9\u05E0\u05D5",
        component: (0, $02bf45b3d71c1dbb$export$2e2bcd8739ae039)
    }
];
const $cc061bb11712ea3a$var$authenticated_pages = [
    {
        url: '/',
        title: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA",
        component: (0, $f891885d951d1681$export$2e2bcd8739ae039)
    },
    {
        url: '/contact',
        title: "\u05D9\u05E6\u05D9\u05E8\u05EA \u05E7\u05E9\u05E8",
        component: (0, $b66f2c7682c2ec23$export$2e2bcd8739ae039)
    },
    {
        url: '/services',
        title: "\u05E9\u05E8\u05D5\u05EA\u05D9\u05DD",
        component: (0, $faa5a36779f74bc4$export$2e2bcd8739ae039)
    },
    {
        url: '/about',
        title: "\u05E2\u05DC\u05D9\u05E0\u05D5",
        component: (0, $02bf45b3d71c1dbb$export$2e2bcd8739ae039)
    },
    {
        url: '/lab',
        title: "\u05EA\u05E4\u05E2\u05D5\u05DC",
        component: (0, $02bf45b3d71c1dbb$export$2e2bcd8739ae039)
    }
];
const $cc061bb11712ea3a$var$HeNavbar = (props)=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $009d538b735550b4$export$2e2bcd8739ae039), {
        bg: "light",
        expand: "lg",
        className: "navbar navbar-expand-lg navbar-light fixed-top",
        id: "mainNav",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $009d538b735550b4$export$2e2bcd8739ae039).Brand, {
                href: $cc061bb11712ea3a$var$homeUrl,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: props.bigImage ? "bigImage" : "smallImage",
                    children: "\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05DE\u05E2\u05D1\u05D3\u05D5\u05EA"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $009d538b735550b4$export$2e2bcd8739ae039).Toggle, {
                "aria-controls": "basic-navbar-nav"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $009d538b735550b4$export$2e2bcd8739ae039).Collapse, {
                id: "basic-navbar-nav",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $208d25fd81f13ee4$export$2e2bcd8739ae039), {
                    className: "mr-auto",
                    children: props.pages.map((p)=>!p.hidden ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $208d25fd81f13ee4$export$2e2bcd8739ae039).Link, {
                            href: $cc061bb11712ea3a$var$baseUrl + p.url,
                            children: p.title
                        }, p.url) : null)
                })
            })
        ]
    });
};
const $cc061bb11712ea3a$var$PageHeader = (props)=>/*#__PURE__*/ (0, $ih19M.jsxs)("header", {
        className: "masthead",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "xxoverlay",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($cc061bb11712ea3a$var$HeNavbar, {
                    ...props
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "col-lg-8 col-md-10 mx-auto",
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: props.bigImage ? "page-heading" : "page-heading-small",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
                                    children: "\u05D0\u05D9\u05D9 \u05D1\u05D9 \u05D0\u05DF \u05DE\u05E2\u05D1\u05D3\u05D5\u05EA"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "subheading",
                                    children: "\u05D0\u05D9\u05DB\u05D5\u05EA \u05E0\u05DE\u05D3\u05D3\u05EA"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
class $cc061bb11712ea3a$var$HeRoot extends (0, $bh6RR.Component) {
    constructor(props){
        super(props);
    //        this.state = { user: null, userToken: null };
    }
    render() {
        const pages = this.props.isAuthenticated ? $cc061bb11712ea3a$var$authenticated_pages : $cc061bb11712ea3a$var$anonymous_pages;
        const bigImage = window.location.pathname == $cc061bb11712ea3a$var$homeUrl;
        return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9d7r6.BrowserRouter), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($cc061bb11712ea3a$var$PageHeader, {
                    bigImage: bigImage,
                    pages: pages
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("hr", {}),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $7094aa3258de9926$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9d7r6.Routes), {
                        children: [
                            pages.map((p)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $9d7r6.Route), {
                                    path: $cc061bb11712ea3a$var$baseUrl + p.url,
                                    Component: p.component
                                }, p.url)),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9d7r6.Route), {
                                Component: (0, $73dec04020112de9$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $95cf7b771e640ce2$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
var $cc061bb11712ea3a$export$2e2bcd8739ae039 = $cc061bb11712ea3a$var$HeRoot;



const $4bd45ab6f71ff72e$var$baseUrl = '/ibn';
class $4bd45ab6f71ff72e$var$App extends (0, $bh6RR.Component) {
    render() {
        return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cc061bb11712ea3a$export$2e2bcd8739ae039), {})
        });
    }
}
var $4bd45ab6f71ff72e$export$2e2bcd8739ae039 = $4bd45ab6f71ff72e$var$App;



var $9ATkq = parcelRequire("9ATkq");
const $c201e13936f81100$var$rootElement = document.getElementById('root');
const $c201e13936f81100$var$root = (0, $9ATkq.createRoot)($c201e13936f81100$var$rootElement);
$c201e13936f81100$var$root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $4bd45ab6f71ff72e$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=ibn_index.035821b0.js.map
